import * as scrollLockLib from './scroll-lock';
import * as pluginLib from './get-plugin';

export const controllerModelLib = {
  ...pluginLib,
  ...scrollLockLib,
};
